import markerIconLocal from '@/assets/sample/map-marker.svg';

const markerIconRemote = '/-/media/foundation/theming/map/mapmarker.svg';

/**
 * Generates Map Marker image url depending on development/public environment.
 *
 * Args:
 *      localPath (String): Optional local image path.
 *      remotePath (String): Optional remote image path.
 *
 * Returns:
 *      (String): Map Marker image url.
 */
export function generateMapMarker(localPath, remotePath) {
    // dev environment, use local path
    if (process.env.VUE_APP_ENV === 'development') {
        return localPath;
    }

    // public environment, use relative path
    if (process.env.VUE_APP_ENV === 'public') {
        return remotePath;
    }

    // connected / editor environments, use CM path
    return process.env.VUE_APP_CM_URL + remotePath;
}

export const markerIcon = generateMapMarker(markerIconLocal, markerIconRemote);
